import React from 'react';
import Header from "../../Header/Header";
import { headerObjEight } from "../../Header/HeaderData";
import CC from "./../../../images/team/profasish.jpg";
import Pres from "./../../../images/team/sukhmani.png";
import VP from "./../../../images/team/susmita.png";
import Director from "./../../../images/team/ph.png";
import Chair from "./../../../images/team/eb10.png";
import Event from "./../../../images/team/eb5.png";
import Tech from "./../../../images/team/ph.png";
import PR from "./../../../images/team/ph.png";
import Tech2 from "./../../../images/team/eb9.png";
import Design1 from "./../../../images/team/bhavana.png";
import Design2 from "./../../../images/team/ph.png";
import Design3 from "./../../../images/team/ph.png";
import Design4 from "./../../../images/team/saurav.png";
import Content1 from "./../../../images/team/chirag.png";
import Content2 from "./../../../images/team/ph.png";

function TeamWIOS() {
    return (
        <div>
            <Header {...headerObjEight} />
            <div className="board-category5">
                <div className="category-title">Diversity.</div>
            </div>
            <div className="mcard-box">
                <div className="mcard-container">
                    <img src={CC} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">Prof. Asish K. Dalai</div>
                    <div className="mcard-title">Club Coordinator, Open Source Community</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
            </div>
            <div className="mcard-box">
            <div className="mcard-container">
                    <img src={Pres} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">Sukhmani Sandhu</div>
                    <div className="mcard-title">President</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
                <div className="mcard-container">
                    <img src={VP} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">Susmita Pal</div>
                    <div className="mcard-title">Vice President</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
                <div className="mcard-container">
                    <img src={Director} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">TBA</div>
                    <div className="mcard-title">Director</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
                <div className="mcard-container">
                    <img src={Chair} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">Anshika Singh</div>
                    <div className="mcard-title">Chairperson</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
                <div className="mcard-container">
                    <img src={Event} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">Manju Bhargavi</div>
                    <div className="mcard-title">Event Lead</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
                <div className="mcard-container">
                    <img src={Tech} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">TBA</div>
                    <div className="mcard-title">Technical Lead</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
                <div className="mcard-container">
                    <img src={PR} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">TBA</div>
                    <div className="mcard-title">PR and Guest Care</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
                <div className="mcard-container">
                    <img src={Tech2} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">Srikurmum Harichandana</div>
                    <div className="mcard-title">Associate Tech Lead</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
                </div>
            <div className="mcard-box">
                <div className="mcard-container">
                    <img src={Design1} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">Bhavana Mokkapati</div>
                    <div className="mcard-title">Editorial Lead</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
                <div className="mcard-container">
                    <img src={Design2} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">Abhay Chaudhary</div>
                    <div className="mcard-title">Graphic Designer</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
                <div className="mcard-container">
                    <img src={Design2} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">Terela Srujan</div>
                    <div className="mcard-title">Graphic Designer</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
                <div className="mcard-container">
                    <img src={Design3} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">Gunotham Solanki</div>
                    <div className="mcard-title">Head of Videography</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
                <div className="mcard-container">
                    <img src={Design4} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">Saurav Menon</div>
                    <div className="mcard-title">Social Media Relations</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
                <div className="mcard-container">
                    <img src={Content1} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">Chirag Gupta</div>
                    <div className="mcard-title">Content Writer</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
                <div className="mcard-container">
                    <img src={Content2} className="mcard-image" alt="ad-img"></img>
                    <div className="mcard-name">Angel Maria</div>
                    <div className="mcard-title">Content Writer</div>
                    <div className="mcard-flex">
                        <div className="b1"></div>
                        <div className="b2"></div>
                        <div className="b3"></div>
                        <div className="b4"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TeamWIOS;
